import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { dataSourceService } from "@/lib/services";
import type { DataDocument, DataResponse } from "@/types";

export type ResponseUploadDataSourceFiles = DataResponse<DataDocument[]>;

export type UploadDataSourceFilesVariables = { collectionUuid: string; files: File[] };

type UploadDataSourceFilesMutationOptions = Omit<
  UseMutationOptions<ResponseUploadDataSourceFiles, Error, UploadDataSourceFilesVariables>,
  "mutationFn"
>;

export const useUploadDataSourceFiles = (options?: UploadDataSourceFilesMutationOptions) => {
  return useMutation<ResponseUploadDataSourceFiles, Error, UploadDataSourceFilesVariables>({
    mutationFn: ({ collectionUuid, files }) => dataSourceService.uploadDocuments(collectionUuid, files),
    ...options,
  });
};
